import { z } from 'zod';
import { ApprovalPreviewSchema, ApprovalRuleSchema, ApprovalSchema, ApprovalVerdictSchema } from '../../entities/approval';
const ref = z.string().trim().min(1).max(200);
const kind = z.string().trim().min(1).max(100);
/**
 * What an app hands `ctx.approvals.request`: the record and stand, the label
 * reviewers see in their list, and the frozen preview. The requester is the
 * member running the function, never a claim of the worker.
 */ export const AppApprovalRequestSchema = z.object({
    kind,
    ref,
    snapshot: z.string().trim().min(1).max(200),
    label: z.string().trim().min(1).max(200),
    url: z.string().url().max(2000).optional(),
    preview: ApprovalPreviewSchema
});
/** The approvals of one record of this app, newest first; optionally one kind. */ export const AppApprovalByRefRequestSchema = z.object({
    ref,
    kind: kind.optional()
});
/** Whether a stand may run: rule off, or its request approved or overridden. */ export const AppApprovalReleaseRequestSchema = z.object({
    kind,
    ref,
    snapshot: z.string().trim().min(1).max(200)
});
export const AppApprovalReleaseSchema = z.object({
    released: z.boolean(),
    approval: ApprovalSchema.nullable()
});
/** Who would get a task if the running member asked now, and by when. */ export const AppApprovalRecipientsRequestSchema = z.object({
    kind
});
export const AppApprovalRecipientsSchema = z.object({
    /** False when the rule is off: the step runs without asking. */ applies: z.boolean(),
    reviewers: z.array(z.object({
        id: z.string(),
        name: z.string()
    })),
    requiredCount: z.number().int().min(0),
    dueAt: z.string().optional(),
    /** Why asking would fail, e.g. too few reviewers besides the requester. */ problem: z.string().optional()
});
/** A new stand voids the open requests of the old one: per record and kind. */ export const AppApprovalWithdrawRequestSchema = z.object({
    kind,
    ref
});
export const AppApprovalIdRequestSchema = z.object({
    approvalId: z.string().min(1)
});
export const AppApprovalDecideRequestSchema = AppApprovalIdRequestSchema.extend({
    verdict: ApprovalVerdictSchema,
    comment: z.string().max(2000).default('')
});
export const AppApprovalOverrideRequestSchema = AppApprovalIdRequestSchema.extend({
    reason: z.string().trim().min(1).max(2000)
});
/** The app's rules, one per kind it names; saving needs a workspace admin. */ export const AppApprovalRulesSchema = z.array(ApprovalRuleSchema).max(50);
export const AppApprovalRulesSaveRequestSchema = z.object({
    rules: AppApprovalRulesSchema
});
export const AppApprovalSchema = ApprovalSchema;

//# sourceMappingURL=app-approvals.schema.js.map